<template>
  <el-dialog
    :title="isEdit ? '获取经纬度' : ''"
    :visible.sync="centerDialogVisible"
    width="600px"
    center
  >
    <div class="dialog-inner">
      <div class="map-search" v-if="isEdit">
        <el-input placeholder="输入地址" v-model="address"></el-input>
        <lb-button size="mini" type="primary" @click="searchMapAddr"
          >搜 索</lb-button
        >
      </div>
      <div class="flex-center pb-lg" style="height: 20px">
        <div class="flex-y-center" v-if="latLng.lng">
          经度：{{ latLng.lng }}
          <div class="ml-md">纬度：{{ latLng.lat }}</div>
        </div>
      </div>
      <div id="container"></div>
    </div>
    <span slot="footer" class="dialog-footer" v-if="isEdit">
      <el-button @click="centerDialogVisible = false">{{
        $t('action.cancel')
      }}</el-button>
      <el-button type="primary" @click="confirmLatLng">{{
        $t('action.comfirm')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'lbMap',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    latLng: {
      type: Object,
      default () {
        return {
          lat: '',
          lng: ''
        }
      }
    },
    address: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      centerDialogVisible: false,
      map: null,
      info: null,
      marker: '',
      geocoder: null
    }
  },
  methods: {
    loadMap () {
      return new Promise(function (resolve, reject) {
        window.openQQMap = function () {
          resolve()
        }
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = `https://map.qq.com/api/js?v=2.exp&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77&callback=openQQMap`
        script.onload = script.onreadystatechange = function () {
          document.body.removeChild(script)
        }
        document.body.appendChild(script)
      })
    },
    initMap () {
      let that = this
      let { lat = '', lng = '' } = this.latLng
      lat = lat || 30.657535
      lng = lng || 104.065783
      this.latLng = { lat, lng }
      let center = new qq.maps.LatLng(lat, lng)
      let map = new qq.maps.Map(document.getElementById('container'), {
        center: center,
        zoom: 12
      })
      that.map = map
      that.info = new qq.maps.InfoWindow({
        map: map
      })
      that.marker = new qq.maps.Marker({
        position: center,
        map
      })
      if (!this.isEdit) return
      qq.maps.event.addListener(map, 'click', function (val, el) {
        if (that.marker) {
          that.marker.setMap(null)
        }
        let { lat, lng } = val.latLng
        that.latLng = val.latLng
        that.marker = new qq.maps.Marker({
          position: new qq.maps.LatLng(lat, lng),
          map: map
        })
      })
    },
    openQQMap () {
      this.initMap()
      this.initGeocoder()
      if (!this.address) return
      this.searchMapAddr()
    },
    /**
     * @method 根据位置搜索坐标
     */
    searchMapAddr () {
      let { address } = this
      this.geocoder.getLocation(address)
    },
    initGeocoder () {
      let that = this
      that.geocoder = new qq.maps.Geocoder()
      that.geocoder.setComplete(function (result) {
        if (that.marker) { that.marker.setMap(null) }
        let { lat, lng } = result.detail.location
        that.latLng = { lat, lng }
        that.map.setCenter(result.detail.location)
        that.marker = new qq.maps.Marker({
          map: that.map,
          position: result.detail.location
        })
      })
      // 若服务请求失败，则运行以下函数
      that.geocoder.setError(function () {
        that.$message.error('请输入包含市级的地址！')
      })
    },
    /**
     * @method 确定经纬度
     */
    confirmLatLng () {
      let that = this
      this.centerDialogVisible = false
      let { lat, lng } = this.latLng
      let geocoder = new qq.maps.Geocoder({
        complete: function (result) {
          let { address, addressComponents } = result.detail
          that.$emit('selectedLatLng', { lat, lng, address, addressComponents })
        }
      })
      geocoder.getAddress(new qq.maps.LatLng(lat, lng))
    }
  },
  watch: {
    dialogVisible (newValue, oldValue) {
      if (newValue) {
        this.centerDialogVisible = true
        var self = this
        this.loadMap().then(function () {
          self.openQQMap()
        })
      }
    },
    centerDialogVisible (val) {
      if (!val) {
        this.$emit('update:dialogVisible', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#container {
  width: 500px;
  height: 400px;
  margin: 0 auto;
}
.dialog-inner {
  .map-search {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    .el-input {
      width: 300px;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basics/lbMap.vue